/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 17:21:56
 * @LastEditTime: 2022-06-10 14:21:37
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/config.tsx
 */
import {
  Form,
  Input, //CompositionInput as Input
} from '@/src/components/Antd';

// import LinkLibrary from '@/src/constrains/LinkLibrary';
import { LinkModuleType } from '@/src/types/common/linkType';
import { useDebounceFn } from 'ahooks';
import { get } from 'lodash';
import React from 'react';
import { generateDisplayName } from 'src/constrains/LinkLibrary/tools';
import { Tip } from 'src/constrains/SlugInput';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { check_redirection } from 'src/request/salesChannel/setting/domain';
import { responseHandler } from 'src/tools/server';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
import LinkLibraryWithSisterScScope from 'src/constrains/LinkLibrary/LinkLibraryWithSisterScScope';
const { Item } = Form;

const urlStar = /\/\/|\*.|[^/]\*/gi;
const urlStartWith = /^(?!\/).*/;

export const redirectColumns = ({
  fields,
  isEditing,
  remove,

  form,
  currentDomain,
  salesChannelUuid,
  getI18n,
}) =>
  // linkListData,
  [
    {
      title: (
        <span>
          {getI18n('salesChannelDomainAndStatus.list.requestURL')}
          <Tip
            getI18n={getI18n}
            title={getI18n(
              'salesChannelDomainAndStatus.list.redirectURLallowedcharacters',
            )}
            extra={
              <React.Fragment>
                <br /> {getI18n('salesChannelDomainAndStatus.list.slash')} (/)
              </React.Fragment>
            }
          />
        </span>
      ),
      dataIndex: 'RequestURL',
      key: 'RequestURL',
      default: true,
      optional: false,
      className: css.columnClass,
      minWidth: 448,
      childGenerate: (text, record, index) => {
        return (
          // <Item shouldUpdate>
          //   {({ getFieldValue }) => {
          //     // form.validateFields('customRedirections').then((re) => {
          //     //   console.log('re', re);
          //     // });
          //     return (
          <Item shouldUpdate>
            {(f) => {
              const { getFieldValue } = f;
              const a = getFieldValue(['customRedirections', index]);
              const { uuid } = a;
              return (
                <Item
                  style={{ width: '100%' }}
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        'salesChannelDomainAndStatus.list.thisfieldisrequired',
                      ),
                    },
                    {
                      validator: async (x, value) => {
                        if (value) {
                          const isGoodStart = urlStartWith.test(value);
                          if (!isGoodStart) {
                            return Promise.reject(
                              new Error(
                                `${getI18n(
                                  'salesChannelDomainAndStatus.list.dontstartwith',
                                )} / `,
                              ),
                            );
                          }
                        }
                      },
                    },
                    {
                      validator: async (x, value) => {
                        if (value) {
                          const isStartFaulty = value.match(urlStar);
                          if (isStartFaulty) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'salesChannelDomainAndStatus.list.pleasefillincorrecturlformat',
                                ),
                              ),
                            );
                          }
                        }
                      },
                    },
                    {
                      validateTrigger: 'onSubmit',
                      validator: async (x, value) => {
                        const data = form.getFieldValue('customRedirections');

                        const sameIndex = (data || []).findIndex((o, i) => {
                          if (i !== index) {
                            const url = get(o, 'url');
                            return url === value;
                          }
                        });

                        // const linkType = get(value, 'linkType');
                        if (sameIndex > -1) {
                          return Promise.reject(
                            new Error(
                              `${getI18n(
                                'salesChannelDomainAndStatus.list.duplicatedwith',
                              )} ${sameIndex + 1}`,
                            ),
                          );
                        }
                      },
                    },
                    {
                      validateTrigger: 'onSubmit',
                      validator: async (x, value) => {
                        if (value) {
                          const res = await check_redirection({
                            url: value,
                            uuid,
                            salesChannelUuid,
                          });
                          const r = responseHandler(res);

                          const { success, errMsg } = r || {};
                          if (!success) {
                            return Promise.reject(
                              new Error(errMsg || `Format error`),
                            );
                          }
                        }
                      },
                    },
                  ]}
                  className={css.missingPageType}
                  name={[fields[index].name, 'url']}>
                  <FormInput
                    currentDomain={currentDomain}
                    isEditing={isEditing}
                    fields={fields}
                    form={form}
                    index={index}
                  />
                </Item>
              );
            }}
          </Item>
          //     );
          //   }}
          // </Item>
        );
      },
    },
    {
      title: getI18n('salesChannelDomainAndStatus.list.destinationURL'),
      dataIndex: 'url',
      key: 'url',
      default: true,
      optional: false,
      className: css.columnClass,
      width: 348,
      childGenerate: (text, record, index) => {
        return (
          <Item
            style={{ width: 348 }}
            className={css.missingPageType}
            name={[fields[index].name, 'linkModule']}
            rules={[
              {
                validator: async (x, value) => {
                  const linkType = get(value, 'linkType');
                  if (!linkType) {
                    return Promise.reject(
                      new Error(
                        getI18n(
                          'salesChannelDomainAndStatus.list.pleasefilllinkmodule',
                        ),
                      ),
                    );
                  }
                },
              },
            ]}>
            <FormLinkModule
              noBottomPadding
              hideTitle
              salesChannelUuid={salesChannelUuid}
              isEditing={isEditing}
              fetchProps={{ onlyShowVisibleProduct: true }}
            />
          </Item>
        );
      },
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      dataIndex: 'action',
      key: 'action',
      default: true,
      optional: false,
      width: 256,
      position: EnumTablePosition.mid,
      align: 'center',
      childGenerate: (text, record, index) => {
        return (
          <Actions
            onDelete={() => {
              remove(index);
              const total = fields.length;
              const list = [];
              for (let i = 0; i < total; i++) {
                const name = _name(i);
                const isTouch = form.isFieldTouched(name);
                // const targetValue = form.getFieldValue(name);
                if (
                  isTouch //|| targetValue
                ) {
                  list.push(i);
                }
              }
              const validateNames = list.map((i) => {
                const name = _name(i);
                return name;
              });
              form.validateFields(validateNames);
            }}
            disableDelete={!isEditing}
          />
        );
      },
    },
  ];

const FormLinkModule = (props) => {
  const { value, onChange, isEditing, ...rest } = props;
  const excludeLinkType = [
    {
      linkType: LinkModuleType.SysModule,
      groups: [LinkModuleType.ShareMiniProgram, LinkModuleType.CustomerService],
    },
  ];
  return isEditing ? (
    <LinkLibraryWithSisterScScope
      data={value}
      onChange={(linkModule) => {
        onChange(linkModule);
      }}
      cannotAddToCart
      presetExcludeLinkType={excludeLinkType}
      {...rest}
    />
  ) : (
    generateDisplayName(value)
  );
};
const _name = (i) => ['customRedirections', i, 'url'];
const recheckOtherParts = ({ fields, index, form }) => {
  const total = fields.length;
  const list = [];
  for (let i = 0; i < total; i++) {
    if (i !== index) {
      const name = _name(i);

      const isTouch = form.isFieldTouched(name);
      // const targetValue = form.getFieldValue(name);
      if (
        isTouch //|| targetValue
      ) {
        list.push(i);
      }
    }
  }
  const validateNames = list.map((i) => {
    const name = _name(i);
    return name;
  });

  return validateNames;
};

const FormInput = (props) => {
  const {
    value,
    onChange,
    isEditing,
    fields,
    index,
    form,
    currentDomain,
    ...rest
  } = props;
  const filter = (str) => {
    if (str) {
      return str.replace(/[^0-9a-zA-Z_*-/]+/gi, '');
    } else {
      return str;
    }
  };
  const { run: check } = useDebounceFn(
    () => {
      const validateNames = recheckOtherParts({ fields, index, form });
      console.log('validateNames', validateNames, index);
      //form.validateFields(validateNames);
    },
    {
      wait: 500,
    },
  );

  return (
    <div className={css.domainContainer}>
      <div>{currentDomain || ''}/</div>
      <div className={css.inputPart}>
        {isEditing ? (
          <Input
            value={value}
            size='large'
            customFilter={filter}
            onChange={(e) => {
              onChange(e);
              check();
            }}
            {...rest}
          />
        ) : (
          value || ''
        )}
      </div>
    </div>
  );
};
